module.exports = __webpack_public_path__ + "static/media/nasa-logo.3a47e562.png";